import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** 返回首页并整页刷新，放弃已崩坏的渲染树，保住项目与章节入口。 */
function handleBackHome() {
    window.location.assign('/');
}
/** 重新加载当前页面，为瞬时渲染异常提供恢复入口。 */
function handleReload() {
    window.location.reload();
}
/**
 * 应用级降级界面：渲染异常时提供返回首页与重新加载两个恢复入口。
 * 同时被 AppErrorBoundary（组件渲染异常）与数据路由 errorElement（路由异常）复用，
 * 保证两条错误路径呈现完全一致的界面。
 */
export function AppErrorScreen() {
    return (_jsxs("main", { className: "app-error", role: "alert", children: [_jsx("h1", { children: "\u9875\u9762\u6682\u65F6\u65E0\u6CD5\u663E\u793A" }), _jsx("p", { children: "\u8BF7\u91CD\u65B0\u52A0\u8F7D\u9875\u9762\u540E\u7EE7\u7EED\u64CD\u4F5C\u3002" }), _jsxs("div", { className: "app-error__actions", children: [_jsx("button", { type: "button", onClick: handleBackHome, children: "\u8FD4\u56DE\u9996\u9875" }), _jsx("button", { type: "button", onClick: handleReload, children: "\u91CD\u65B0\u52A0\u8F7D" })] })] }));
}
